import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + testimonials.length) % testimonials.length);
  };
  const active = testimonials[index];
  return <section className="bg-white py-24 sm:py-32" data-id="element-334" data-mp="2x0tgyhw10knu">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-335" data-mp="2x1l2t0ztn40x">
        <Reveal data-id="element-336" data-mp="2s28e0ape3mvp">
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-337" data-mp="2s2rwptmv6fas">
            <div className="max-w-2xl" data-id="element-338" data-mp="v9oqvq9qrs5m">
              <Eyebrow data-id="element-339" data-mp="v8nb58hs6hhk">Testimonials</Eyebrow>
              <h2 className="mt-6 font-display text-[clamp(2.1rem,5vw,3.6rem)] leading-[1.02] tracking-[-0.02em] text-navy-900" data-id="element-340" data-mp="q9tz7ki56yji">
                Our Work <span className="italic text-brass-dark" data-id="element-341" data-mp="h4dcylqnjo46">Speaks for Itself.</span>
              </h2>
            </div>
            <div className="flex gap-3" data-id="element-342" data-mp="m2ydkm9tg9t5">
              <button type="button" onClick={() => go(index - 1)} aria-label="Previous testimonial" className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-navy-900/15 text-navy-900 transition-colors hover:border-brass hover:bg-brass hover:text-navy-900" data-id="element-343" data-mp="78ab7gzpprhr">
                <ChevronLeft className="h-5 w-5" aria-hidden="true" data-id="element-344" data-mp="14xdeihfoucjm" />
              </button>
              <button type="button" onClick={() => go(index + 1)} aria-label="Next testimonial" className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-navy-900/15 text-navy-900 transition-colors hover:border-brass hover:bg-brass hover:text-navy-900" data-id="element-345" data-mp="q4jx2qguvmcb">
                <ChevronRight className="h-5 w-5" aria-hidden="true" data-id="element-346" data-mp="1xgpkpdrp2u94" />
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-347" data-mp="1sh37v5fs3g0u">
          <div className="relative mt-12 overflow-hidden rounded-2xl bg-cream p-8 ring-1 ring-navy-900/5 sm:p-14" data-id="element-348" data-mp="1ogt13qk5wlkx">
            <Quote className="absolute right-8 top-8 h-16 w-16 text-brass/15" aria-hidden="true" data-id="element-349" data-mp="1jh6dcn6pjmxv" />
            <AnimatePresence mode="wait" custom={direction} data-id="element-350" data-mp="1el7uff45ex4u">
              <motion.figure key={active.id} custom={direction} initial={{
              opacity: 0,
              x: direction * 32
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -32
            }} transition={{
              duration: 0.45,
              ease: [0.22, 1, 0.36, 1]
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.15} onDragEnd={(_, info) => {
              if (info.offset.x < -60) go(index + 1);
              if (info.offset.x > 60) go(index - 1);
            }} className="cursor-grab active:cursor-grabbing" data-id="element-351" data-mp="19rdcoh83ss8e">
                <div className="flex gap-1" aria-label={`${active.rating} out of 5 stars`} data-id="element-352" data-mp="3cgeouxy2c25j">
                  {Array.from({
                  length: active.rating
                }).map((_, i) => <Star key={i} className="h-4 w-4 fill-brass text-brass" aria-hidden="true" data-id="element-353" data-mp="2jqo4w89r261i" data-mpi={i} />)}
                </div>
                <blockquote className="mt-7 max-w-3xl font-display text-[clamp(1.35rem,3vw,2.1rem)] leading-[1.3] tracking-[-0.01em] text-navy-900" data-id="element-354" data-mp="2sq1i9c0zveri">
                  &ldquo;{active.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-8 text-sm" data-id="element-355" data-mp="20zod6zavei4j">
                  <span className="font-semibold text-navy-900" data-id="element-356" data-mp="25103z85hd9eb">{active.name}</span>
                  <span className="text-ink-700/60" data-id="element-357" data-mp="1lwn9z738mbtp"> — {active.location}</span>
                </figcaption>
              </motion.figure>
            </AnimatePresence>

            <div className="mt-10 flex items-center gap-2" data-id="element-358" data-mp="1gzn00l39ooxb">
              {testimonials.map((item, i) => <button key={item.id} type="button" onClick={() => go(i)} aria-label={`Show testimonial ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? 'w-8 bg-brass' : 'w-3 bg-navy-900/15 hover:bg-navy-900/30'}`} data-id="element-359" data-mp="1voswi1aq011i" data-mpi={i} />)}
            </div>
          </div>
        </Reveal>

        <p className="mt-5 text-[12px] uppercase tracking-[0.14em] text-ink-700/45" data-id="element-360" data-mp="k7jhps2jdx6j">
          Placeholder reviews shown — replace with verified customer testimonials.
        </p>
      </div>
    </section>;
}